import React, { useState, useEffect, useReducer } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Checkbox from '@mui/material/Checkbox'
import FormControl from '@mui/material/FormControl'
import FormControlLabel from '@mui/material/FormControlLabel'
import FormGroup from '@mui/material/FormGroup'
import InputLabel from '@mui/material/InputLabel'
import MenuItem from '@mui/material/MenuItem'
import Paper from '@mui/material/Paper'
import Select from '@mui/material/Select'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { EMPTY_OBJECT } from './AddTaskList'

function CreateDataSourceFromExisting(props) {
    const [isLoadingRequest, setIsLoadingRequest] = useState(false)
    const [databaseId, setDatabaseId] = useState(-1)
    const [databaseName, setDatabaseName] = useState('')
    const [dataSourceName, setDataSourceName] = useState('')
    const [sqLDbList, setSqLDbList] = useState([])

    const [sourceDatabaseId, setSourceDatabaseId] = useState(-1)
    const [sourceDatabaseName, setSourceDatabaseName] = useState('')
    const [dataSourcesForSourceDatabase, setDataSourcesForSourceDatabase] = useState([])
    const [dataSourceSystemNameForSourceDatabase, setDataSourceSystemNameForSourceDatabase] = useState('')
    const [dimensionComparison, setDimensionComparison] = useState([])

    const [selectedDimension, setSelectedDimension] = useState('')
    const [dimensionMembers, setDimensionMembers] = useState([])
    const [dimensionMembersDisplay, setDimensionMembersDisplay] = useState([])
    const [loadedMembers, setLoadedMembers] = useState([])
    const [searchTerm, setSearchTerm] = useState('')
    const [membersToRemove, setMembersToRemove] = useState([])

    const [doNotImportFacts, setDoNotImportFacts] = useState(false)
    const [getFactsAllMembers, setGetFactsAllMembers] = useState(true)
    const [getFactsForSpecificMembers, setGetFactsForSpecificMembers] = useState(false)

    const [errorMessage, setErrorMessage] = useState('')

    const [, forceUpdate] = useReducer(x => x + 1, 0)

    /**
     * Trigger on component mount
     */
    useEffect(() => {
        if (sqLDbList.length === 0) {
            let dBList = props.databases.filter(x => x.serverType == 0)
            setSqLDbList(dBList)
        }

        setIsLoadingRequest(true)

        // This is true if we are in edit mode
        if (props.taskData.databaseId !== -1) {
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setDataSourceName(props.taskData.dataSourceName)
        }

        // Fill in the selections for the origin database
        if (props.taskData.originDatabaseId !== -1) {
            setSourceDatabaseId(props.taskData.originDatabaseId)

            let getDataSources = props.getDataSources(props.taskData.originDatabaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setDataSourcesForSourceDatabase(json)
                setDataSourceSystemNameForSourceDatabase(props.taskData.originDatabaseDataSourceSystemName)
                setMembersToRemove(props.taskData.membersToRemove)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDataSourcesForSourceDatabase([])
            })
        }

        // Set comparison model if it was previously set
        if (props.taskData.appendDimensionInfo) {
            setDimensionComparison(props.taskData.appendDimensionInfo)
        }

        // Set checkboxes
        if (props.taskData.doNotImportFacts && props.taskData.doNotImportFacts === true) {
            setDoNotImportFacts(true)
            setGetFactsAllMembers(false)
            setGetFactsForSpecificMembers(false)
        }

        if (props.taskData.getFactsAllMembers && props.taskData.getFactsAllMembers === true) {
            setDoNotImportFacts(false)
            setGetFactsAllMembers(true)
            setGetFactsForSpecificMembers(false)
        }

        if (props.taskData.getFactsForSpecificMembers && props.taskData.getFactsForSpecificMembers === true) {
            setDoNotImportFacts(false)
            setGetFactsAllMembers(false)
            setGetFactsForSpecificMembers(true)
            setMembersToRemove(props.taskData.membersToRemove)
        }

        if (props.taskData.databaseId === -1 && props.taskData.originDatabaseId === -1) {
            setIsLoadingRequest(false)
        }
    }, [])

    useEffect(() => {
        if (props.taskData.databaseId !== -1) {
            setIsLoadingRequest(false)
            setDatabaseId(props.taskData.databaseId)
            setDatabaseName(props.taskData.databaseName)
            setDataSourceName(props.taskData.dataSourceName)
        } else {
            setIsLoadingRequest(false)
            setDatabaseId(-1)
            setDatabaseName('')
        }
    }, [props.taskData.databaseId, props.taskData.databaseName, props.taskData.dataSourceName])
    
    useEffect(() => {
        if (props.taskData.originDatabaseId !== -1) {
            setSourceDatabaseId(props.taskData.originDatabaseId)

            let getDataSources = props.getDataSources(props.taskData.originDatabaseId)
            getDataSources.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setDataSourcesForSourceDatabase(json)
                setDataSourceSystemNameForSourceDatabase(props.taskData.originDatabaseDataSourceSystemName)
                setMembersToRemove(props.taskData.membersToRemove)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDataSourcesForSourceDatabase([])
            })
        }
    }, [props.taskData.originDatabaseId, props.taskData.originDatabaseDataSourceSystemName, props.taskData.membersToRemove])

    useEffect(() => {
        if (props.taskData.appendDimensionInfo) {
            setDimensionComparison(props.taskData.appendDimensionInfo)
        }
    }, [props.taskData.appendDimensionInfo])

    useEffect(() => {
        if (props.taskData.doNotImportFacts && props.taskData.doNotImportFacts === true) {
            setDoNotImportFacts(true)
            setGetFactsAllMembers(false)
            setGetFactsForSpecificMembers(false)
        }

        if (props.taskData.getFactsAllMembers && props.taskData.getFactsAllMembers === true) {
            setDoNotImportFacts(false)
            setGetFactsAllMembers(true)
            setGetFactsForSpecificMembers(false)
        }

        if (props.taskData.getFactsForSpecificMembers && props.taskData.getFactsForSpecificMembers === true) {
            setDoNotImportFacts(false)
            setGetFactsAllMembers(false)
            setGetFactsForSpecificMembers(true)
            setMembersToRemove(props.taskData.membersToRemove)
        }
    }, [props.taskData.doNotImportFacts, props.taskData.getFactsAllMembers, props.taskData.getFactsForSpecificMembers])

    function handleDatabase(event) {
        event.preventDefault()
        setIsLoadingRequest(false)
        setDatabaseId(event.target.value)
        setDatabaseName('')
        setDataSourceSystemNameForSourceDatabase('')
        setDimensionComparison([])
        setMembersToRemove([])
        setErrorMessage('')

        let dbName = ""
        sqLDbList.forEach(db => {
            if (db.id === event.target.value) {
                setDatabaseName(db.dBname)
                dbName = db.dBname
            }
        })
    }

    /**
     * Handles changing the source database
     * @param {any} event - Front end event from the control
     */
    function handleSourceDatabaseChange(event) {
        event.preventDefault()
        setIsLoadingRequest(true)
        setSourceDatabaseId(event.target.value)
        setSourceDatabaseName('')
        setDataSourceSystemNameForSourceDatabase('')
        setDimensionComparison([])
        setMembersToRemove([])
        setErrorMessage('')

        let dbName = ""
        sqLDbList.forEach(db => {
            if (db.id === event.target.value) {
                setSourceDatabaseName(db.dBname)
                dbName = db.dBname
            }
        })

        let getDataSources = props.getDataSources(event.target.value)
        getDataSources.then((resp) => { 
            if (resp.status !== 200) {
                throw new Error(resp)
            } else {
                return resp.json()
            }
        }).then((json) => {
            setIsLoadingRequest(false)
            setDataSourcesForSourceDatabase(json)
            fireOnSaveEvent(databaseId, databaseName, dataSourceName, event.target.value, "", dimensionComparison, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
        }).catch((ex) => {
            console.error(ex)
            setIsLoadingRequest(false)
            setSourceDatabaseName('')
            setDataSourceSystemNameForSourceDatabase('')
            setDataSourcesForSourceDatabase([])
        })
    }

    /**
     * Handles changing the data source from the source database (as opposed to the target database)
     * @param {any} event - Front end event from the control
     */
    function handleDataSourceSecondaryChange(event) {
        event.preventDefault()
        setDataSourceSystemNameForSourceDatabase(event.target.value)
        setDimensionComparison([])
        setMembersToRemove([])
        setErrorMessage('')

        if (event.target.value !== "" && databaseId > -1 && sourceDatabaseId > -1) {
            setIsLoadingRequest(true)

            let dimensionsComparisonReq = props.getDimensions(sourceDatabaseId, event.target.value)
            dimensionsComparisonReq.then((resp) => { 
                if (resp.status !== 200 && resp.status !== 400) {
                    throw new Error(resp)
                } else if (resp.status === 400) {
                    return resp.json()
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                
                if (typeof json === 'string' || json instanceof String) {
                    setDataSourceSystemNameForSourceDatabase('')
                    setDimensionComparison([])
                    setMembersToRemove([])
                    setErrorMessage(json)
                } else {
                    let buildObject = []
                    let defaultChecked = []

                    for (let x = 0; x < json.length; x++) {
                        buildObject.push({
                            "dimensionName": json[x]["alias"],
                            "dimensionAlias": json[x]["alias"],
                            "systemName": json[x]["systemName"],
                            "type": json[x]["typeOfDimension"],
                            "segmentation": true,
                            "nameMasking": true,
                            "selected": true,
                            "members": json[x]["members"]
                        })
                        defaultChecked.push({ "dimensionSystemName": json[x]["systemName"], "memberId": "-1", "remove": true })
                    }
    
                    setDimensionComparison(buildObject)
                    setMembersToRemove(defaultChecked)
                    fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, event.target.value, buildObject, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                }
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDataSourceSystemNameForSourceDatabase('')
                setDimensionComparison([])
                setMembersToRemove([])

                // TODO: Set some error message here to inform the user of a problem
            })
        } else {
            setDimensionComparison([])
            setMembersToRemove([])
        }
    }

    function handleDimensionChange(event) {
        event.preventDefault()
        setErrorMessage('')
        setSelectedDimension(event.target.value)
        setDimensionMembers([])
        setIsLoadingRequest(true)
        callDimensionMembersFromDropDown(event.target.value)
    }

    function renderDimensionCompareCheckboxes(comparison, message) {
        if (message === '') {
            return comparison.filter(x => x.systemName !== 'Measures').map((dimension, index) => {
                return <div key={`dimension-group-${index}`}>
                    <FormControlLabel key={`dimension-group-${dimension["type"]}`}
                        label={dimension["dimensionName"]}
                        control={
                            <Checkbox
                              checked={dimension["selected"]}
                              onChange={(e) => {
                                e.preventDefault()
                                
                                let copiedDimensionCompare = dimensionComparison
                                for (let i = 0; i < copiedDimensionCompare.length; i++) {
                                    if (copiedDimensionCompare[i]["type"] === dimension["type"]) {
                                        copiedDimensionCompare[i]["selected"] = e.target.checked
                                    }
                                }
                                setDimensionComparison(copiedDimensionCompare)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, copiedDimensionCompare, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                                forceUpdate()
                            }}/>}>
                            {dimension["dimensionName"]}
                    </FormControlLabel>
                    <Box sx={{ display: 'flex', flexDirection: 'column', ml: 3 }}>
                        <FormControlLabel
                            label="Segmentation"
                            control={<Checkbox checked={dimension["segmentation"] && dimension["selected"]} onChange={(e) => {
                                e.preventDefault()
    
                                let copiedDimensionCompare = dimensionComparison
                                for (let i = 0; i < copiedDimensionCompare.length; i++) {
                                    if (copiedDimensionCompare[i]["type"] === dimension["type"]) {
                                        copiedDimensionCompare[i]["segmentation"] = e.target.checked
                                    }
                                }
                                setDimensionComparison(copiedDimensionCompare)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, copiedDimensionCompare, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                                forceUpdate()
                            }} />}
                        />
                        <FormControlLabel
                            label="Name Masking"
                            control={<Checkbox checked={dimension["nameMasking"] && dimension["selected"]} onChange={(e) => {
                                e.preventDefault()
    
                                let copiedDimensionCompare = dimensionComparison
                                for (let i = 0; i < copiedDimensionCompare.length; i++) {
                                    if (copiedDimensionCompare[i]["type"] === dimension["type"]) {
                                        copiedDimensionCompare[i]["nameMasking"] = e.target.checked
                                    }
                                }
                                setDimensionComparison(copiedDimensionCompare)
                                fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, copiedDimensionCompare, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                                forceUpdate()
                            }} />}
                        />
                    </Box>
                </div>
            })
        } else {
            return <Typography style={{ "color": "#f00" }}>{message}</Typography>
        }
    }

    function renderDimensionMemberSelectArea() {
        if (getFactsForSpecificMembers) {
            return <Box sx={{ width: '100%', bgcolor: 'background.paper', maxHeight: '400px', overflowY: 'scroll', marginTop: '15px' }}>
            <FormGroup>
                <FormControl className="field" fullWidth>
                    <Select
                        onChange={handleDimensionChange}
                        value={selectedDimension}
                        defaultValue={''}
                        displayEmpty
                        required
                        fullWidth
                        disabled={isLoadingRequest}>
                            <MenuItem value={''}>Select Dimension</MenuItem>
                            { dimensionComparison.map((x) => x && 
                                <MenuItem key={x.systemName} value={x.systemName}>{x.dimensionAlias}</MenuItem>
                            )}
                    </Select>
                </FormControl>
                <FormControl className="field" fullWidth>
                    <TextField
                        fullWidth
                        label="Search For Dimension Member"
                        variant="outlined"
                        value={searchTerm}
                        disabled={false}
                        onChange={(e) =>
                            {
                                e.preventDefault()
                                setSearchTerm(e.target.value)
                                let filtered = filterOutMembersBySearchTerm(e.target.value, dimensionMembers, false)
                                setDimensionMembersDisplay(filtered)
                    }} />
                </FormControl>
                <FormControl className="field" fullWidth>
                    {
                        dimensionMembersDisplay.map((member, memberIndex) => 
                            <FormControlLabel
                                key={`dimension-member-${memberIndex}`}
                                control={
                                    <Checkbox
                                        checked={membersToRemove && membersToRemove.filter(x => x.dimensionSystemName === selectedDimension && x.memberId === member.systemName && x.remove).length > 0}
                                        onChange={(e) => {
                                            e.preventDefault()
                                            let lookup = false
                                            let copied = membersToRemove
                                            if (copied) {
                                                for (let x = 0; x < copied.length; x++) {
                                                    if (copied[x]["dimensionSystemName"] === selectedDimension && copied[x]["memberId"] === member.systemName) {
                                                        lookup = true
                                                        copied[x]["remove"] = e.target.checked
                                                    }
                                                }
                                            } else {
                                                copied = []
                                            }
                                            
                                            // Add entry if we didn't save it beforehand
                                            if (!lookup) {
                                                copied.push({ "dimensionSystemName": selectedDimension, "memberId": member.systemName, "remove": e.target.checked })
                                            }
                    
                                            fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, copied, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                                            setMembersToRemove(copied)
                                            forceUpdate()
                                        }}
                                    />
                                }
                                label={member.alias}>
                            </FormControlLabel>
                        )
                    }
                </FormControl>
                <Button variant="contained" disabled={isLoadingRequest} onClick={callDimensionMembersFromButton}>Load More Members</Button>
            </FormGroup>
        </Box>
        }

        return null
    }

    /**
     * If component has a prop for the [onSave] event, the purpose of this is to fire that event with the latest information
     * @param {int} dbId - Selected Target Database ID
     * @param {string} dbName - Selected Name of the Target Database
     * @param {string} dsName - Data source name
     * @param {int} originDbId - Selected Origin Database ID
     * @param {string} originSourceSystemName - Selected Name of the Origin Database
     * @param {object} comparison - Comparison Model From The State
     * @param {array} membersSelected - All Members selected from member selection control
     * @param {boolean} dontImportFacts - Do Not Import Facts
     * @param {boolean} allMembers - Import Facts For All Members
     * @param {boolean} someMembers - Import Facts For Some Members
     */
    function fireOnSaveEvent(dbId, dbName, dsName, originDbId, originSourceSystemName, comparison, membersSelected, dontImportFacts, allMembers, someMembers) {
        if (props.onSave) {
            let copied = JSON.parse(JSON.stringify(EMPTY_OBJECT))
            copied["databaseId"] = dbId
            copied["databaseName"] = dbName
            copied["dataSourceName"] = dsName
            copied["membersToRemove"] = membersSelected
            copied["originDatabaseId"] = originDbId
            copied["originDatabaseDataSourceSystemName"] = originSourceSystemName
            copied["appendDimensionInfo"] = comparison
            copied["doNotImportFacts"] = dontImportFacts
            copied["getFactsAllMembers"] = allMembers
            copied["getFactsForSpecificMembers"] = someMembers
            props.onSave(copied)
        }
    }

    function callDimensionMembersFromDropDown(dimensionSystemName) {
        if (dimensionSystemName !== 'Measures') {
            let getDimensionMembersCall = props.getDimensionMembers(sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionSystemName, [], searchTerm)
            getDimensionMembersCall.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)
                setDimensionMembers(json)
                
                let filtered = filterOutMembersBySearchTerm(searchTerm, json, true)
                setDimensionMembersDisplay(filtered)

                // Add already loaded to the state
                let copiedAlreadyLoaded = loadedMembers
                for (let x = 0; x < json.length; x++) {
                    copiedAlreadyLoaded.push(json[x]["systemName"])
                }
                setLoadedMembers(copiedAlreadyLoaded)
                fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDimensionMembers([])
                setLoadedMembers([])
            })
        }
        else {
            setIsLoadingRequest(false)
            
            for (let x = 0; x < dimensionComparison.length; x++) {
                if (dimensionComparison[x]["type"] === -1) {
                    setDimensionMembers(dimensionComparison[x]["members"])

                    let filtered = filterOutMembersBySearchTerm('', dimensionComparison[x]["members"], dimensionComparison[x]["members"].filter(x => x.systemName === '-1').length === 0)
                    setDimensionMembersDisplay(filtered)
                }
            }
        }
    }

    function callDimensionMembersFromButton() {
        if (selectedDimension !== 'Measures') {
            setIsLoadingRequest(true)
        
            let getDimensionMembersCall = props.getDimensionMembers(sourceDatabaseId, dataSourceSystemNameForSourceDatabase, selectedDimension, loadedMembers, searchTerm)
            getDimensionMembersCall.then((resp) => { 
                if (resp.status !== 200) {
                    throw new Error(resp)
                } else {
                    return resp.json()
                }
            }).then((json) => {
                setIsLoadingRequest(false)

                let copiedMembers = dimensionMembers.concat(json)
                setDimensionMembers(copiedMembers)

                let filtered = filterOutMembersBySearchTerm(searchTerm, copiedMembers, false)
                setDimensionMembersDisplay(filtered)
                
                // Add already loaded to the state
                let copiedAlreadyLoaded = loadedMembers
                for (let x = 0; x < json.length; x++) {
                    copiedAlreadyLoaded.push(json[x]["systemName"])
                }
                setLoadedMembers(copiedAlreadyLoaded)
                forceUpdate()
            }).catch((ex) => {
                console.error(ex)
                setIsLoadingRequest(false)
                setDimensionMembers([])
                setLoadedMembers([])
            })
        }
        else {
            setIsLoadingRequest(false)

            for (let x = 0; x < dimensions.length; x++) {
                if (dimensions[x]["typeOfDimension"] === -1) {
                    setDimensionMembers(dimensions[x]["members"])

                    let filtered = filterOutMembersBySearchTerm('', dimensions[x]["members"], false)
                    setDimensionMembersDisplay(filtered)
                }
            }
        }
    }

    function filterOutMembersBySearchTerm(searchTerm, allMembers, includeAllMembers) {
        if (searchTerm.trim().length === 0) {
            if (includeAllMembers) {
                allMembers.unshift({"alias": "ALL DIMENSION MEMBERS","systemName": "-1","attributes": {},"children": []})
            }
            return allMembers
        } else {
            let rtnVal = []
            for (let x = 0; x < allMembers.length; x++) {
                if (allMembers[x]["alias"].toLowerCase().indexOf(searchTerm.toLowerCase().trim()) > -1) {
                    rtnVal.push(allMembers[x])
                }
            }
            if (includeAllMembers) {
                rtnVal.unshift({"alias": "ALL DIMENSION MEMBERS","systemName": "-1","attributes": {},"children": []})
            }
            return rtnVal
        }
    }

    // This is the render logic, no need to declare another method is a functional component
    return (
        <Paper elevation={3} className="dbFunctionsPaper">
            <h3>Create Data Source From Existing</h3>
            <FormControl className="field" fullWidth>
                <InputLabel id="target-databse-label">Target Database</InputLabel>
                <Select
                    labelId="target-databse-label"
                    id="target-databse"
                    label="Target Database"
                    onChange={handleDatabase}
                    defaultValue={-1}
                    value={databaseId}
                    required
                    fullWidth
                    disabled={isLoadingRequest}>
                        <MenuItem value={-1}>Select Database</MenuItem>
                        { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                </Select>
            </FormControl>
            <FormControl className="field" fullWidth>
                <TextField
                    fullWidth
                    label="Data Source Name"
                    variant="outlined"
                    value={dataSourceName}
                    disabled={false}
                    onChange={(e) => {
                        e.preventDefault()
                        setDataSourceName(e.target.value)
                        fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, membersToRemove, doNotImportFacts, getFactsAllMembers, getFactsForSpecificMembers)
                    }} />
            </FormControl>
            <Paper elevation={6} square style={{ "padding": "10px", "marginTop": "15px" }}>
                <h4>Select Source Database</h4>
                <FormControl className="field" fullWidth>
                    <InputLabel id="source-databse-label">Source Database</InputLabel>
                    <Select
                        labelId="source-databse-label"
                        id="source-databse"
                        label="Source Database"
                        onChange={handleSourceDatabaseChange}
                        defaultValue={-1}
                        value={sourceDatabaseId}
                        required
                        fullWidth
                        disabled={isLoadingRequest}>
                            <MenuItem value={-1}>Select Database</MenuItem>
                            { sqLDbList.map((x) => x && <MenuItem key={x.id} value={x.id}>{x.dBname}</MenuItem>)}
                    </Select>
                </FormControl>
                <FormControl className="field" fullWidth>
                    <InputLabel id="source-datasource-label">Source Data Source</InputLabel>
                    <Select
                        labelId="source-datasource-label"
                        id="source-datasource"
                        label="Source Data Source"
                        onChange={handleDataSourceSecondaryChange}
                        value={dataSourceSystemNameForSourceDatabase}
                        defaultValue={''}
                        required
                        fullWidth
                        disabled={isLoadingRequest}>
                            <MenuItem value={''}>Select Data Source</MenuItem>
                            { dataSourcesForSourceDatabase.map((x) => x && <MenuItem key={x.key} value={x.key}>{x.value}</MenuItem>) }
                    </Select>
                </FormControl>
            </Paper>
            <Paper elevation={6} square style={{ "padding": "10px", "marginTop": "15px" }}>
                <h4>Copy Data Elements From Source</h4>
                {renderDimensionCompareCheckboxes(dimensionComparison, errorMessage)}
            </Paper>
            <Paper elevation={6} square style={{ "padding": "10px", "marginTop": "15px" }}>
                <h4>Dimension Members</h4>
                <FormControlLabel label="Do Not Import Facts"
                    control={
                        <Checkbox
                            checked={doNotImportFacts}
                            onChange={(e) => {
                                e.preventDefault()
                            
                                if (e.target.checked) {
                                    setDoNotImportFacts(true)
                                    setGetFactsAllMembers(false)
                                    setGetFactsForSpecificMembers(false)
                                    fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, membersToRemove, true, false, false)
                                }
                                
                                forceUpdate()
                        }}/>}>
                </FormControlLabel>
                <FormControlLabel label="Get Facts For All Dimension Members"
                    control={
                        <Checkbox
                            checked={getFactsAllMembers}
                            onChange={(e) => {
                                e.preventDefault()
                            
                                if (e.target.checked) {
                                    setDoNotImportFacts(false)
                                    setGetFactsAllMembers(true)
                                    setGetFactsForSpecificMembers(false)
                                    fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, membersToRemove, false, true, false)
                                }

                                forceUpdate()
                        }}/>}>
                </FormControlLabel>
                <FormControlLabel label="Get Facts For The Following Dimension Members"
                    control={
                        <Checkbox
                            checked={getFactsForSpecificMembers}
                            onChange={(e) => {
                                e.preventDefault()
                                
                                if (e.target.checked) {
                                    setDoNotImportFacts(false)
                                    setGetFactsAllMembers(false)
                                    setGetFactsForSpecificMembers(true)
                                    fireOnSaveEvent(databaseId, databaseName, dataSourceName, sourceDatabaseId, dataSourceSystemNameForSourceDatabase, dimensionComparison, membersToRemove, false, false, true)
                                }

                                forceUpdate()
                        }}/>}>
                </FormControlLabel>
                {renderDimensionMemberSelectArea()}
            </Paper>
        </Paper>)
}

export default CreateDataSourceFromExisting